var _circle, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45.2 13.2",
    style: {
      enableBackground: "new 0 0 45.2 13.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 6.6,
    cy: 6.6,
    r: 6.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.1,0c-1.6,0-3,0.6-4.2,1.5c1.1,1.4,1.8,3.2,1.8,5.1s-0.7,3.7-1.8,5.1c1.1,0.9,2.6,1.5,4.2,1.5c3.6,0,6.6-2.9,6.6-6.6 C23.7,3,20.7,0,17.1,0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.6,0c-1.6,0-3,0.6-4.2,1.5c1.1,1.4,1.8,3.2,1.8,5.1s-0.7,3.7-1.8,5.1c1.1,0.9,2.6,1.5,4.2,1.5c3.6,0,6.6-2.9,6.6-6.6 C34.2,3,31.2,0,27.6,0z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.4,0c2,1.5,3.4,3.9,3.4,6.6s-1.3,5.1-3.4,6.6h12.8V0H32.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.22f4f546a72b855c38c93015330bb585.svg";
export { ForwardRef as ReactComponent };